var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxMessageRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66218 1.67578C4.96065 1.67578 1.94922 4.08506 1.94922 7.04615C1.94922 8.99828 3.22334 10.749 5.3057 11.7009V15.1017L8.89042 12.4132C12.4866 12.3172 15.3751 9.94615 15.3751 7.04615C15.3751 4.08506 12.3637 1.67578 8.66218 1.67578ZM8.66218 11.0739H8.43864L6.64829 12.4165V10.794L6.21799 10.6282C4.41288 9.9334 3.29181 8.5606 3.29181 7.04615C3.29181 4.82483 5.70109 3.01837 8.66218 3.01837C11.6233 3.01837 14.0326 4.82483 14.0326 7.04615C14.0326 9.26747 11.6233 11.0739 8.66218 11.0739Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMessageRounded);
export default __webpack_public_path__ + "static/media/bx-message-rounded.e4d45e8336e48934bb36922fdd00d30b.svg";
export { ForwardRef as ReactComponent };